import { VehicleRecommendationsApiResponse } from './types';

interface getVehicleRecommendationsParams {
    stockNumberList?: string[];
    visitorId: string;
    userStoreId: string;
}

export async function getVehicleRecommendations({
    stockNumberList,
    visitorId,
    userStoreId,
}: getVehicleRecommendationsParams): Promise<VehicleRecommendationsApiResponse> {
    try {
        const searchParams = new URLSearchParams();

        if (stockNumberList && stockNumberList.length > 0) {
            const sortedStockNumberList = stockNumberList.sort();
            sortedStockNumberList.forEach((s) => {
                searchParams.append('stockNumbers', s);
            });
        }

        searchParams.set('visitorId', visitorId);
        searchParams.set('userStoreId', userStoreId);
        const url = `/home/api/recommendations?${searchParams.toString()}`;

        return await fetch(url)
            .then((response) => response.json())
            .then((data: VehicleRecommendationsApiResponse) => {
                if (data && data.items && data.items.length > 0) {
                    return data;
                }
                return {} as VehicleRecommendationsApiResponse;
            })
            .catch(() => {
                return {} as VehicleRecommendationsApiResponse;
            });
    } catch {
        return Promise.resolve({} as VehicleRecommendationsApiResponse);
    }
}
